export const safeParse = (str: unknown): any => {
  if (typeof str === "string") {
    return JSON.parse(str);
  }
  return null;
};
